import {useGetSettings} from '@/modules/settings/api'
import {findAppropiateLanguage} from '@cypro/ui/integrations/tolgee/instance'
import {useTolgee} from '@tolgee/react'
import {useCallback} from 'react'
import type {LabelTranslate} from './types'

const LABEL_NS = 'cleanroom'

/**
 * The label is printed in the organisation's default language, not the language the user picked
 * for themselves (CY-252). Resolves once that language's texts are loaded.
 */
export function useLabelTranslate() {
  const tolgee = useTolgee()
  const {settings} = useGetSettings()
  const language = findAppropiateLanguage(settings?.language) || 'en'

  return useCallback(async (): Promise<LabelTranslate> => {
    await tolgee.loadRecord({language, namespace: LABEL_NS})
    return (key, params) => tolgee.t({key, ns: LABEL_NS, language, params})
  }, [tolgee, language])
}
